import { lazy } from 'react';

export { default as StaticLoading } from './loading';
export { default as ThirdLoading } from './thirdLoading';
export { default as InputNumber } from './inputNumber';
export { default as StaticToast } from './toast';
export { default as Card } from './card';
export { default as Empty } from './emptyCover';
export { default as SvgIcon } from './svg';
export { default as DrugItem } from './drugItem';
export { default as FixedButton } from './fixedbutton';
export { default as FormatPrice } from './formatPrice';
export { default as O2OExpress } from './o2oExpress';
export { default as Coupon } from './coupon';
export { default as RadioGroup } from './RadioGroup';
export { default as FileInput } from './FileInput';
export { default as LoginPopup } from './LoginPopup';
export { default as OrderStatusHeader } from './OrderStatusHeader';
